export default __webpack_public_path__ + "static/media/Helveticaneuecyr-light.a0284e4c.woff";